import * as THREE from "three"
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader.js"
import {DRACOLoader} from "three/examples/jsm/loaders/DRACOLoader"

const gltfLoader = new GLTFLoader()
const dracoLoader = new DRACOLoader()

dracoLoader.setDecoderPath("node_modules/three/examples/jsm/libs/draco/")
dracoLoader.setDecoderConfig({type: "js"})
gltfLoader.setDRACOLoader(dracoLoader)

let heatpointModel = null

function loadModel(modelUrl, callback) {
	gltfLoader.load(modelUrl, (model) => {
		model.scene.scale.set(0.07, 0.07, 0.07)
		model.scene.children[0].material.emissive.setHex(0x004f9f)
		model.scene.children[0].material.metalness = 0.1
		model.scene.children[0].material.roughness = 0.1
		model.scene.children[1].material.transparent = true
		model.scene.children[1].material.opacity = 0.2
		model.scene.children[2].material.metalness = 0.4
		model.scene.children[2].material.roughness = 0.4
		callback(model.scene)
	})
}

export default class Heatpoint extends THREE.Object3D {
	constructor(textureUrl = null, modelUrl = "model/heatointbrige.glb") {
		super()
		this.color = 0x004f9f
		this.modelLoaded = false
		this.pendingColor = null

		if (heatpointModel !== null) {
			this.pin = heatpointModel.clone()
			this.add(this.pin)
			this.modelLoaded = true
		} else {
			loadModel(modelUrl, (model) => {
				if (textureUrl !== null) {
					this.textureLoader.load(textureUrl, (texture) => {
						const material = new THREE.MeshStandardMaterial({color: this.color, map: texture})
						const material2 = new THREE.MeshStandardMaterial({color: this.color, map: texture})
						material.emissive.setHex(this.color)
						material.metalness = 0.9
						material.roughness = 0.9

						material2.emissive.setHex(this.color)
						material2.metalness = 0.9
						material2.roughness = 0.9
						material.transparent = true
						material.opacity = 0.2

						model.children[0].material = material
						model.children[1].material = material2
						model.children[2].material = material2

						this.pin = model
						this.add(this.pin)
						this.modelLoaded = true

						// Apply pending color if it exists
						if (this.pendingColor) {
							this.setColor(this.pendingColor)
							this.pendingColor = null
						}
					})
				} else {
					this.pin = model
					this.add(this.pin)
					this.modelLoaded = true

					// Apply pending color if it exists
					if (this.pendingColor) {
						this.setColor(this.pendingColor)
						this.pendingColor = null
					}
				}
			})
		}
	}

	setColor(color) {
		if (!this.modelLoaded) {
			this.pendingColor = color
			return
		}

		this.color = color

		const material = new THREE.MeshStandardMaterial({color: this.color})
		const material2 = new THREE.MeshStandardMaterial({color: this.color})
		const material3 = new THREE.MeshStandardMaterial({color: 0xffffff})

		material.emissive.setHex(this.color)
		material.metalness = 0.9
		material.roughness = 0.9

		material2.emissive.setHex(this.color)
		material2.metalness = 0.9
		material2.roughness = 0.9
		material.transparent = true
		material.opacity = 0.2

		material3.emissive.setHex(0x666666)
		material3.metalness = 0.4
		material3.roughness = 0.4

		this.pin.children[0].material = material
		this.pin.children[1].material = material2
		this.pin.children[2].material = material3
	}
}
